import React from 'react';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { Container, Button, Row, Col } from 'reactstrap';

import Dashboard from "./Dashboard/";
import Deposits from "./Deposits/";
import Sidebar from "./Sidebar/Sidebar";
import {ToastContainer} from "react-toastify";
import Status from "./Status/Status";
import Verification from "./Verification";
import Settings from "./Settings";

import Modals from "./Modals"

import Login from "./Login"

const routes = [
  {
    path: "/",
    exact: true,
    sidebar: () => <div>Dashboard!</div>,
    main: () => <Dashboard/>
  },
  {
    path: "/deposits/:depoId/verifications/:verifId",
    sidebar: () => <div>Verification page</div>,
    main:  ({match}) => <Verification key={match.params.verifId} depo_id={match.params.depoId} verif_id={match.params.verifId}/>
  },
  {
    path: "/deposits",
    exact: false,
    sidebar: () => <div>Deposits!</div>,
    main:  () => <Deposits/>
  },
  {
    path: "/settings",
    sidebar: () => <div>Settings!</div>,
    main:  () => <Settings/>
  },
  {
    path: "/status",
    sidebar: () => <div>Status!</div>,
    main:  () => <Status/>
  },
  {
    path: "/login",
    sidebar: () => <div>Login!</div>,
    main:  () => <Login/>
  }
];

class Layout extends React.Component {
  render() {
    return (<div>
        <div style={{height: "100%", width: "250px", position: "fixed", zIndex: 1, top: 0, left: 0, backgroundColor: "#38314f", overflowX: "hidden", paddingTop: 20}}>
          <Sidebar/>
        </div>
        <div style={{marginLeft: "250px"}}>
          <Container fluid>

            <Row noGutters>
              <Col xs={12}>
                {routes.map((route, index) => (
                  // Render more <Route>s with the same paths as
                  // above, but different components this time.
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={route.main}
                  />
                ))}
              </Col>
            </Row>

          </Container>
        </div>

        <ToastContainer position="bottom-right"/>
        <Modals/>
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js